// Simple navigation permissions utility
// Replaces the CASL-based navigation permissions

/**
 * Check if user is an agent with limited access
 */
export function isAgentWithLimitedAccess(): boolean {
    return localStorage.getItem('userRole') === 'org:agent';
}

/**
 * Check if user has navigation access (placeholder for future implementation)
 */
export function hasNavigationAccess(permission: string): boolean {
    // For now, return true for all permissions
    // This can be enhanced later with actual permission checking
    return true;
} 